var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09247 14.25C6.93822 14.2495 6.78571 14.2173 6.64443 14.1554C6.50315 14.0934 6.37612 14.0031 6.27122 13.89L0.803724 8.07377C0.599342 7.85596 0.489855 7.56588 0.499349 7.26735C0.508843 6.96881 0.636541 6.68628 0.85435 6.4819C1.07216 6.27751 1.36224 6.16803 1.66077 6.17752C1.95931 6.18701 2.24184 6.31471 2.44622 6.53252L7.08122 11.4713L16.5425 1.12127C16.6385 1.00171 16.7579 0.903038 16.8935 0.831318C17.029 0.759597 17.1778 0.716343 17.3306 0.70421C17.4835 0.692078 17.6372 0.711324 17.7824 0.760766C17.9275 0.810209 18.061 0.888803 18.1747 0.991723C18.2884 1.09464 18.3798 1.21971 18.4434 1.35926C18.507 1.4988 18.5414 1.64987 18.5444 1.80318C18.5475 1.95649 18.5192 2.10881 18.4612 2.25078C18.4033 2.39276 18.3169 2.52139 18.2075 2.62877L7.92497 13.8788C7.82107 13.9939 7.69448 14.0863 7.55315 14.1502C7.41182 14.2141 7.25881 14.2481 7.10372 14.25H7.09247Z",
    fill: "#C79D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f34a9cb1fa7065c0fb0f6dc351c3c20e.svg";
export { ForwardRef as ReactComponent };